<template>
  <div class="container-fluid mt-2">
    <h1>Prozesse</h1>
    <div style="float:right;">
      <button @click="createProcess" class="btn btn-secondary">Neuer Prozess</button>
    </div>
    <div class="toolbar">
      <div class="form-inline">
        <label>Prozess-Definition:</label>
        <div class="input-group ml-3">
          <div class="input-group-prepend">
            <button id="upload" @click="uploadProcess" class="btn btn-secondary">Upload</button>
          </div>
          <div class="custom-file">
            <input type="file" @change="updateFilename" class="custom-file-input" id="processfile" aria-describedby="upgroup">
            <label class="custom-file-label" for="upgroup">{{ filename }}</label>
          </div>
        </div>
      </div>
    </div>
    <br/>
    <b-tabs>
      <b-tab title="Laufende Prozesse">
        <b-table @row-clicked="openRunning" :items="activeRows" :fields="activeFields" striped hover>
        </b-table>
      </b-tab>
      <b-tab title="Definitionen">
        <b-table @row-clicked="openDefinition" ref="deftable" :items="defRows" :fields="defFields" striped hover>
        </b-table>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import router from '@/router'
import workflows from '@/modules/workflows.js'

export default {
  name: 'ProcessOverview',
  components: {
  },
  data() {
    return {
      filename: 'Datei wählen...',
      activeRows: [],
      activeFields: [
        {label: 'ID',key: "id"},
        {label: 'Prozess',key:'key'},
        {label: 'Aufgabe',key:'activity.name'},
        {label: 'Mitarbeiter', key: 'activity.assignee'}
      ],
      defRows: [{name:"test"}],
      defFields: [
        {label: 'DID',key: 'depid'},
        {label: 'Kennung',key:'key'},
        {label: 'Beschreibung',key:'name'},
        {label: 'Version',key:'version'},
      ],
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    updateFilename() {
      var ifile = document.getElementById('processfile');
      if (ifile.files && ifile.files.length > 0) {
        this.filename = ifile.files[0].name;
      }
    },
    createProcess: function() {
      router.push({name: 'ProcessEditor',params:{}});
    },
    fetchData: function() {
      var self = this;
      workflows.definitions(this,function(data) {
        console.log(data);
        self.defRows = data;
      })
      workflows.actives(this,function(data) {
        self.activeRows = data;
        console.log(data);
      })
    },
    openDefinition: function(row) {
      router.push({name: 'ProcessDefinition',params:{defid: row.id }});
    },
    openRunning: function(row) {
      router.push({name: 'ProcessHistoryEntry',params: { id: row.id }});
    },
    uploadProcess: function() {
      var files = document.getElementById('processfile').files;
      var self = this;
      workflows.upload(files).then(function(resp) {
        if (resp.status < 400) {
          self.$bvToast.toast('Prozessdefinition aktualisiert.',{title: 'Prozessdefinitionen',variant: 'success'})
          self.fetchData();
        } else {
          resp.text().then(function(data) {
            self.$bvToast.toast('Fehler bei Prozess Upload: ' + data,{title: 'Prozess Upload',variant:'danger'});            
          });
        }
      }).catch(function(err) {
        self.$bvToast.toast('Fehler bei Prozess Upload: ' + JSON.stringify(err),{title: 'Prozess Upload',variant:'danger'});
      })
    },
  }
}
</script>
